<div class="tutorization--block__column">
  <div *ngIf="stats" class="tutorization--block__row">
    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">
          {{ 'questions.widgets.rightAnswersPercentage' | translate }}
        </div>
        <div class="dashboard-card-item-text text-centered">{{ stats.percentage | percent }}</div>
      </div>
    </div>

    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">
          {{ 'questions.widgets.ratioAnswersPerQuestion' | translate }}
        </div>
        <div class="dashboard-card-item-text text-centered">{{ stats.ratioAnswers | number : '1.2-2' }}</div>
      </div>
    </div>

    <div class="tutorization--block__item">
      <div class="dashboard-card-item">
        <div class="dashboard-card-item-title text-centered">
          {{ 'questions.widgets.totalQuestionsCreated' | translate }}
        </div>
        <div class="dashboard-card-item-text text-centered">{{ stats.totalQuestionCreated }}</div>
      </div>
    </div>
  </div>

  <div id="group-questions">
    <lms-mars1-questions-list
      #groupQuestions
      [listId]="listId"
      [options]="listOptions"
      (listUpdated)="setCollection($event)"
    ></lms-mars1-questions-list>
  </div>
</div>
